import React from 'react';

import { useDispatch } from 'react-redux';

import { Button } from '@mui/material';

import { submitUpdatesForm } from '~/actions/order';

import { FRAUD_STATUS, PATCH_UPDATE_FRAUD_STATUS } from '~/consts/order';

import UsersService from '~/services/UsersService';

interface Props {
  purchases: Array<App.Order>;
  userId: string;
}

export function MarkAllFraud({ purchases, userId }: Props) {
  const dispatch = useDispatch();

  const handleClick = async () => {
    const confirmed = window.confirm(
      'Are you sure you want to mark all orders as fraud? This should not be done for account takeovers. This should only be done when every action since the creation of the account has been fraudulent.',
    );
    if (!confirmed) {
      return;
    }
    const fraudPayload = {
      op: PATCH_UPDATE_FRAUD_STATUS,
      fraudStatus: FRAUD_STATUS.MANUAL_REVIEWED_FRAUD,
    };

    try {
      await Promise.all(purchases.map((purchase) => dispatch(submitUpdatesForm(purchase.id, fraudPayload))));
      await UsersService.toggle({
        id_member: userId,
        toggle_name: 'shadow_ban_user',
        toggle_value: true,
      });
      alert(
        'Completed. All orders have been marked as fraud. This customer has been shadow banned. Click OK to refresh the page.',
      );
      window.location.reload();
    } catch (error) {
      console.error('Failed to mark orders as fraud:', error);
      alert('Error, try again');
    }
  };

  return (
    <Button variant="outlined" size="small" onClick={handleClick} sx={{ mt: 1 }}>
      Mark Entire Account as Fraud
    </Button>
  );
}
